'use strict';

var base = require('./base');

module.exports = function () {
    let $bp = window.matchMedia('(max-width: 48em)').matches ? 'mobile' : 'desktop';
    let autoReplenishToggle = document.querySelector('og-optin-toggle');
    let elStyle = document.createElement('style');

    elStyle.textContent = `
       .btn.checkbox {
            position: absolute;
            top: auto;
            right: 1.75rem;
            width: 2.9375rem;
            height: 1.3125rem;
            background-color: var(--color-grey-aa);
            border-color: var(--color-grey-aa);
            color: #fff;
            border-radius: 1rem;
            text-align: right;
            transition: text-align 0.3s ease-in-out;
            cursor: pointer;
       }
       .btn.checkbox.active {
           text-align: left;
       }
       .btn.checkbox::before {
           content: "";
           position: absolute;
           top: 0.25rem;
           left: 0.25rem;
           display: block;
           width: 0.6875rem;
           height: 0.6875rem;
           border-radius: 50%;
           background-color: var(--color-white);
           transition: left 0.3s ease-in-out, right 0.3s ease-in-out;
       }
       .btn.checkbox.active::before {
            left: auto;
            right: 0.25rem;
       }
       .btn.checkbox::after {
            color: var(--color-white);
            background: transparent;
            border-radius: 1rem;
            content: "OFF";
            font-size: 0.6875rem;
            font-weight: 600;
            line-height: 1rem;
            padding: 0.063rem 0 0 0.938rem;
            text-align: right;
       }
       .btn.checkbox.active::after {
            content: "ON";
            line-height: 1rem;
            padding: 0.063rem 0.938rem 0 0;
            background: transparent;
            color: var(--color-white);
            text-align: left;
            transform: unset;
        }
        .text-link:focus {
            outline: 2px solid #000;
        }
    `;

    if (autoReplenishToggle != null) {
        autoReplenishToggle.shadowRoot.appendChild(elStyle);
    }

    // Toggle flyout for ingredients
    $('body').on('click', '.ingredients-toggle', function () {
        $('body').addClass('flyout-active ingredients-active');
        $('body').find('.ingredients-flyout .close').focus();
    });

    $('body').on('click', '.add-to-cart', function () {
        if ($bp === 'mobile') {
            base.showBagAlert();
        }
    });

    // Close custom alert
    $('body').on('click', '.close-alert', function () {
        $('.product-alert').removeClass('active');
    });

    //click on background
    $('body').on('click', '.flyout-background', function () {
        if ($('.singleVariant button.add-to-cart').is(':disabled') && $('.backInStockEnabled').length === 1) {
            $('.product-inventory-messaging').addClass('d-md-block').addClass('d-none');
        }
    });
    // Close attributes
    $('body').on('click', '.attributes-container .close', function () {
        $('.mobile-attributes-wrap').removeClass('active');
        $('body').removeClass('flyout-active drawer-active');
        if ($('.singleVariant button.add-to-cart').is(':disabled') && $('.backInStockEnabled').length === 1) {
            $('.product-inventory-messaging').addClass('d-md-block').addClass('d-none');
        }
    });

    // Close attributes
    $('body').on('click', '.attributes-btn', function () {
        $('body').addClass('flyout-active drawer-active');
        $('.mobile-attributes-wrap').addClass('active');
        $('.singleVariant .backInStockEnabled.product-inventory-messaging').removeClass('d-none').removeClass('d-md-block');
    });

    // Handle promo modal(s)
    $('body').on('show.bs.modal', $('.promo-modal'), function (e) {
        var promoTrigger = $(e.relatedTarget);
        var promoCallout = promoTrigger.data('callout');
        var promoDetails = promoTrigger.data('details');

        $(this).find('.modal-title').text(promoCallout);
        $(this).find('.modal-body').html(promoDetails);
        $(this).find('.close').focus();
    }).on('hidden.bs.modal', function () {
        $(this).find('.modal-title').text('');
        $(this).find('.modal-body').empty();
        $(this).find('.close').blur();

      
    });

    // Steps Product Content btn
    $('body').on('click', '.step-content .btn', function (e) {
        e.preventDefault();
        $('.step-slider').slick('slickNext');
    });

    /**
    * Set Steps Slider content
    */
    function setStepSliderContent() {
        let stepCount = parseInt($('.step-slider').parent().data('steps'), 10);

        if ($bp === 'desktop') {
            if ($('.step-slider .step-content').length) {
                $('.step-slider').slick('slickRemove', 0);
            }
            if (stepCount <= 2) {
                $('.slick-prev, .slick-next').hide();
            } else {
                $('.slick-prev, .slick-next').show();
            }
        }
    }

    $(window).smartresize(function () {
        $bp = window.matchMedia('(max-width: 48em)').matches ? 'mobile' : 'desktop';
        setStepSliderContent();
    });

    $(document).ready(function(){
        setStepSliderContent();
    });

    let scale = 1;
    const zoomStep = 0.1;
    $(document).on('keydown', function(event) {
        var zoomContainer = $('.main-carousel-container .slick-active');
        var image = zoomContainer.find('img');
        
        if (event.key === '+' || event.key === '=') {
            scale += zoomStep;
        } else if (event.key === '-' || event.key === '_') {
            scale = Math.max(zoomStep, scale - zoomStep);
        }
    
        image.css('transform', `scale(${scale})`);
    });

    checkBIS();
};
